module.exports = __webpack_public_path__ + "static/img/bigDataImg.bb34eae.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/bigDataImg.webp
// module id = JWvc
// module chunks = 1